<div class="relative flex flex-col border border-[#E4E4E4] rounded-[6px] h-[355px] overflow-hidden">
  <!-- Iframe Area -->
  <div class="relative flex w-full h-[235px] bg-[#F5F5F5] justify-center items-center overflow-hidden">
    @if (type === SmartAdType.BANDEROLE) {
      <iframe class="w-auto h-full"
      src="/assets/iframes/smart-banderole.html"></iframe>
    }
    @if (type === SmartAdType.RECTANGLE) {
      <iframe width="300" height="250" class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 scale-x-[1.10] md:scale-x-[0.90]   scale-y-[0.97]"
      src="/assets/iframes/medium-rectangle.html"></iframe>
    }
  </div>

  <!-- Content Area -->
  <div class="flex flex-col p-4">
    <span class="text-2xl text-[#161D26]/50 font-bold line-clamp-2 break-words hyphens-auto">Lokale Anzeige</span>
  </div>

  <!-- Bottom Labels -->
  <span class="absolute right-4 bottom-2.5 text-xs text-[#999999]/70 font-medium">Werbung</span>
</div>
